<template>
  <div class="vh-100 main-section">
    <div class="container pt-5 px-4">
      <img src="/img/logopriadi.png" width="180" alt="" />
      <div class="my-3 text-white">
        <p class="fw-bolder fs-3 p-0 my-0">{{ $t('welcome') }}</p>
        <p class="fs-6 p-0 mb-5">{{ $t('loginPageSubtitle') }}</p>
      </div>

      <form @submit.prevent="authenticate">
        <div class="form-floating mb-3 d-block">
          <input
            v-model="email"
            type="email"
            class="form-control"
            id="floatingInput"
            :placeholder="$t('emailHint')"
            autofocus />
          <label for="floatingInput"><i class="bi bi-envelope-fill me-2"></i> {{ $t('email') }}</label>
          <small class="text-danger mb-3">
            {{ errors.email }}
          </small>
        </div>

        <div class="form-floating mb-5 d-block">
          <input
            v-model="password"
            type="password"
            class="form-control"
            id="floatingPassword"
            :placeholder="$t('passwordHint')" />
          <label for="floatingPassword"><i class="bi bi-key-fill me-2"></i> {{ $t('password') }}</label>
          <small class="text-danger mb-3">
            {{ errors.password }}
          </small>
        </div>

        <div class="d-grid gap-2 col-3 w-100 mb-5">
          <button class="btn btn-primary shadow text-white" type="submit">
            {{ $t('signin') }}
          </button>
        </div>
      </form>
      
      <p class="text-center" v-if="currentRole === 'individual'">
        {{ $t('noaccount') }}
        <router-link to="/register" class="fw-bold text-decoration-none text-primary">{{ $t('signup') }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Login',
  data() {
    return {
      errors: {},
      email: '',
      password: '',
    }
  },
  computed: {
    currentRole() {
      return this.$store.getters.getRole
    }
  },
  mounted() {
    if (this.$store.getters.isAuth) {
      this.$router.push('/transactions')
    }
  },
  methods: {
    async authenticate() {
      this.errors = {}
      
      // Validate inputs
      if (!this.email) {
        this.errors.email = this.$t('validation.required', { field: this.$t('email') })
      }
      if (!this.password) {
        this.errors.password = this.$t('validation.required', { field: this.$t('password') })
      }
      
      // Exit if validation failed
      if (Object.keys(this.errors).length > 0) {
        return
      }

      try {
        // Login
        await axios.post(
          '/api/login',
          {
            email: this.email,
            password: this.password,
          },
          { withCredentials: true }
        )
        
        // Set auth state
        this.$store.dispatch('setAuth', true)
        
        // Fetch user data
        try {
          const response = await axios.get('/api/user', { withCredentials: true })
          this.$store.dispatch('setUser', response.data)
        } catch (error) {
          console.error('Failed to fetch user:', error)
          this.$store.dispatch('setUser', { id: null, email: null })
          this.$store.dispatch('setAuth', false)
          throw error
        }
        
        // Navigate based on role
        const nextRoute = this.currentRole === 'hr' ? '/transactions' : '/package'
        this.$router.push(nextRoute)
      } catch (error) {
        console.error('Authentication error:', error)
        const errorMsg = error.response?.data?.detail || 'An error occurred during login'
        Swal.fire({
          icon: 'error',
          title: 'Oops',
          text: errorMsg,
        })
      }
    },
  },
}
</script>

<style scoped>
.main-section {
  background-image: linear-gradient(to top, rgba(0, 119, 138, 0.9), rgba(0, 187, 216, 0.8)), url('/img/login.png');
  background-size: contain;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}
</style>
